require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-alex-schwabauer-bs-raven.json") })
        }
      }, "path---package-unpublished-alex-schwabauer-bs-raven");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-alex-schwabauer-bs-raven!./.cache/json/package-unpublished-alex-schwabauer-bs-raven.json
// module id = 929
// module chunks = 231608221292675